import React from "react";
import { Button } from "semantic-ui-react";
import ReactTable, { ReactTableDefaults } from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/pro-regular-svg-icons";
import { saveAs } from "file-saver";
import moment from "moment";

import { combineCountAndPercent, exportCountAndPercentHeaders, exportCountAndPercentValues } from "../../../util/common";

const KeylockerPin = ({ report, t }) => {
  if (!Array.isArray(report.report_data) || report.report_data.length < 1) {
    return (
      <>
        <h3 className="report-heading">{t(report.report_name).message || report.report_name}</h3>
        <p className="no-data">{t("no_data").message || "No data"}</p>
      </>
    );
  }

  const data = report.report_data.map(d => JSON.parse(d));

  const exportData = async () => {
    let csv = "";
    let header = (t("location").message || "Location") + ", ";
    header += (t("wo_count").message || "WO Count") + ", ";
    header += exportCountAndPercentHeaders(t("pin_from_check_in").message || "Pin from check-in", t) + ", ";
    header += exportCountAndPercentHeaders(t("pin_from_phone_number").message || "Pin from phone#", t) + ", ";
    header += exportCountAndPercentHeaders(t("pin_from_reg_number").message || "Pin from reg#", t) + ", ";
    header += exportCountAndPercentHeaders(t("key_dropped").message || "Key dropped", t) + ", ";
    header += exportCountAndPercentHeaders(t("key_drop_back_for_appointment").message || "Key drop back for appointment", t);

    let values = data
      .map(d => {
        let v =
          d.location +
          ", " +
          d.wo_count +
          ", " +
          exportCountAndPercentValues(d.key_drop_check_in, d.key_drop_check_in_percent) +
          ", " +
          exportCountAndPercentValues(d.key_drop_phone_number, d.key_drop_phone_number_percent) +
          ", " +
          exportCountAndPercentValues(d.key_drop_reg_number, d.key_drop_reg_number_percent) +
          ", " +
          exportCountAndPercentValues(d.key_drop_for_appointment, d.key_drop_for_appointment_percent) +
          ", " +
          exportCountAndPercentValues(d.key_drop_back_for_appointment, d.key_drop_back_for_appointment_percent);

        return v;
      })
      .join("\n");

    csv += header + "\n" + values;
    saveAs(new File([csv], { type: "text/csv;charset=utf-8" }), "KeylockersOverview" + moment().format("YYYYMMDD") + ".csv");
  };

  return (
    <>
      <h3 className="report-heading">
        {t(report.report_name).message || report.report_name}
        <Button color="green" floated="right" basic onClick={() => exportData()}>
          <span style={{ marginRight: "10px" }}>{t("export").message || "Export"}</span>
          <FontAwesomeIcon icon={faFileExport} />
        </Button>
      </h3>
      <div className="dealer-reports-table-container">
        <ReactTable
          className="ReactTable -floated-table no-overflow all-data-table -initial-margin"
          data={data}
          showPagination={false}
          showPageSizeOptions={false}
          sortable={false}
          style={{ maxHeight: "600px" }}
          resizable={false}
          defaultPageSize={data.length || 0}
          pageSize={data.length || 0}
          noDataText={
            <div className="Table__no-results">
              <p>{t("no_data").message || "No data"}</p>
            </div>
          }
          column={{
            ...ReactTableDefaults.column,
            headerClassName: "ReactTable__column-header dealer-table-header",
            className: "ReactTable__column",
          }}
          columns={[
            {
              Header: <strong>{t("location").message || "Location"}</strong>,
              accessor: "location",
            },
            {
              Header: <strong>{t("wo_count").message || "WO Count"}</strong>,
              accessor: "wo_count",
            },
            {
              Header: <strong>{t("pin_from_check_in").message || "Pin from check-in"}</strong>,
              id: "key_drop_check_in",
              accessor: d => combineCountAndPercent(d.key_drop_check_in, d.key_drop_check_in_percent),
            },
            {
              Header: <strong>{t("pin_from_phone_number").message || "Pin from phone#"}</strong>,
              id: "key_drop_phone_number",
              accessor: d => combineCountAndPercent(d.key_drop_phone_number, d.key_drop_phone_number_percent),
            },
            {
              Header: <strong>{t("pin_from_reg_number").message || "Pin from reg#"}</strong>,
              id: "key_drop_reg_number",
              accessor: d => combineCountAndPercent(d.key_drop_reg_number, d.key_drop_reg_number_percent),
            },
            {
              Header: <strong>{t("key_drop_for_appointment").message || "Key dropped (WO %)"}</strong>,
              id: "key_drop_for_appointment",
              accessor: d => combineCountAndPercent(d.key_drop_for_appointment, d.key_drop_for_appointment_percent),
            },
            {
              Header: <strong>{t("key_drop_back_for_appointment").message || "Key drop back for appointment"}</strong>,
              id: "key_drop_back_for_appointment",
              accessor: d => combineCountAndPercent(d.key_drop_back_for_appointment, d.key_drop_back_for_appointment_percent),
            },
          ]}
        />
      </div>
    </>
  );
};

export { KeylockerPin };
